import { useEffect, useState } from 'react';
import { proxyExchangeCodeForToken } from '../../api/services/auth/proxyExchangeCodeForToken';
import { exchangeCodeForToken } from '../../api/services/auth/exchangeCodeForToken';
import Loader from './../Common Utility/Loader'; // Import the Loader component

const AuthCallback = () => {
    // const { login } = useAuth();
    const [loading, setLoading] = useState(true); // Add loading state
    const [error, setError] = useState(null); // Add error state

    const getAccessToken = async (code, codeVerifier) => {
        const proxyRequest = process.env.REACT_APP_IDP_PROXY_REQUEST === 'TRUE';
        const accessToken = proxyRequest
            ? await proxyExchangeCodeForToken(code, codeVerifier)
            : await exchangeCodeForToken(code, codeVerifier);
        return accessToken;
    };

    useEffect(() => {

        
        const handleAuthCallback = async () => {
            const params = new URLSearchParams(window.location.search);
            // const state = params.get('state');
            const code = params.get('code');
            

            if (!code) {
                setLoading(false);
                sessionStorage.removeItem('pathtoRedirect'); // Clear the stored path
                sessionStorage.removeItem('user'); // Clear the user session
                sessionStorage.removeItem('code_verifier'); // Clear the code verifier
                sessionStorage.removeItem('session_state'); // Clear the session state
                window.location.href = '/';
                return;
            }
            const session_state = params.get('session_state');
            sessionStorage.setItem('session_state',session_state ); // Store the session state in session storage
            

            const codeVerifier = sessionStorage.getItem('code_verifier'); // Retrieve the code verifier from session storage
            if (!codeVerifier) {
                setError('Code verifier is missing.');
                setLoading(false);
                window.location.href = '/'; // Redirect to home if code verifier is missing
                return;
            }

            try {
                // Exchange the authorization code for an access token
                const accessToken = await getAccessToken(code, codeVerifier);

                if (accessToken) {
                    // Store the access token in session storage
                    sessionStorage.setItem('user', accessToken);

                    // login(accessToken); // Call the login function with the access token
                    window.location.href = sessionStorage.getItem('pathtoRedirect') || '/'; // Redirect to the original state or home
                } else {
                    setError('Failed to retrieve access token.');
                }
            } catch (error) {
                console.error('Error during authentication:', error);
                setError('An error occurred during authentication. Please try again.');
            } finally {
                setLoading(false);
            }
        };

        handleAuthCallback();
    } );

    if (loading) {
        return <Loader />; // Show the Loader while processing
    }

    if (error) {
        return (
            // <div style={{ textAlign: 'center', marginTop: '20px', color: 'red' }}>
            //     <p>{error}</p>
            //     <button onClick={() => window.location.reload()}>Retry</button>
            // </div>
            <Loader />
        );
    }

    return null; // Return null if no loading or error
};

export default AuthCallback;